export default __webpack_public_path__ + "static/media/9.1acc3d84.png";